import DeleteFilesModal from './DeleteFilesModal.component';

export default DeleteFilesModal;